import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import style from '../../Styles/Dasbboard.module.css';
import { useDispatch } from 'react-redux';
import { MONTHS } from '../../constant/constant';
import { generateYears } from '../../ReusableFn/reusableFn';

import {
  setColumn,
  setFilterMonth,
  setFilterYear,
} from '../../store/reducers/filterState';

import DashboardFilters from './DashboardFilters';
import DashboardApi from '../../Api/DashboardApi';
import { useAuth } from '../../Context/AuthContext';
import { toastError } from '../Toast/ToastComponent';
import useFilterStateData from '../../customHooks/useFilterStateData';

import Dashboard from './DashboardContent';
import SurveyDashboard from './SurveyDashboard';

const DashboardComp = () => {
  const dispatch = useDispatch();
  const { authState } = useAuth();

  const { month: filterStateMonth, year: filterStateYear } =
    useFilterStateData();

  const location = useLocation();
  const navigate = useNavigate();

  const [dashboardType, setDashboardType] = useState(
    location.pathname.includes('surveydashboard') ? 'survey_dashboard' : 'dashboard'
  );

  useEffect(() => {
    if (location.pathname.includes('surveydashboard')) {
      setDashboardType('survey_dashboard');
    } else {
      setDashboardType('dashboard');
    }
  }, [location.pathname]);

  const [dashData, setDashData] = useState({
    overallStatus: [],
    projectReport: [],
    leaveTaken: [],
    permissionTaken: [],
    lockedCount: [],
  });

  let filterArr = {
    month: filterStateMonth,
    year: filterStateYear,
  };

  const filterArray = [
    {
      options: [
        { label: 'Dashboard', value: 'dashboard' },
        { label: 'Survey Dashboard', value: 'survey_dashboard' },
      ],
      optionFilterProp: 'label',
      placeholder: 'Dashboard',
      defaultValue: location.pathname.includes('surveydashboard') ? 'survey_dashboard' : 'dashboard',
      controlName: 'dashboardType',
      allowClear: false,
      input: 'select',
    },
    {
      options: MONTHS,
      optionFilterProp: 'label',
      placeholder: 'Month',
      defaultValue: filterStateMonth,
      controlName: 'month',
      allowClear: false,
      input: 'select',
    },
    {
      options: generateYears() || [],
      optionFilterProp: 'label',
      placeholder: 'Year',
      defaultValue: filterStateYear,
      controlName: 'year',
      allowClear: false,
      input: 'select',
    },
  ];

  const handleFilterChange = (value, controlName) => {
    if (controlName === 'dashboardType') {
      setDashboardType(value);
      if (value === 'survey_dashboard') {
        navigate('/dashboard/surveydashboard');
      } else {
        navigate('/dashboard');
      }
      return;
    }

    filterArr = { ...filterArr, [controlName]: value };

    dispatch(setColumn([]));

    if (controlName === 'month') {
      dispatch(setFilterMonth(value));
    }

    if (controlName === 'year') {
      dispatch(setFilterYear(value));
    }

    getDashData();
  };

  const getDashData = async () => {
    const reqData = {
      ...filterArr,
      userRoleID: authState?.userRoleID,
      id: authState?.id,
    };

    try {
      const [
        overallStatus,
        projectReport,
        leaveTaken,
        permissionTaken,
        lockedCount,
      ] = await Promise.all([
        DashboardApi.overAllReport(reqData),
        DashboardApi.userProjectReport(reqData),
        DashboardApi.leaveTakenReport(reqData),
        DashboardApi.permissionTakenReport(reqData),
        DashboardApi.lockedCount(reqData),
      ]);

      setDashData({
        overallStatus: overallStatus?.data?.result,
        projectReport: projectReport?.data?.result,
        leaveTaken: leaveTaken?.data?.result,
        permissionTaken: permissionTaken?.data?.result,
        lockedCount: lockedCount?.data?.result,
      });
    } catch (err) {
      toastError(err.message);
    }
  };

  useEffect(() => {
    getDashData();
  }, []);

  return (
    <section className={style.dashboard}>
      <div className="d-flex px-1 px-lg-0 justify-content-between justify-content-lg-end">
        <DashboardFilters
          filterArray={filterArray}
          handleFilterChange={handleFilterChange}
        />
      </div>

      {dashboardType === 'dashboard' && (
        <Dashboard dashData={dashData} filterArr={filterArr} />
      )}

      {dashboardType === 'survey_dashboard' && (
        <SurveyDashboard month={filterStateMonth} year={filterStateYear} />
      )}
    </section>
  );
};

export default DashboardComp;
